"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddCategoria = void 0;
var React = require("react");
var FetchCategoria_1 = require("./FetchCategoria");
var categoria = 'http://localhost:5220/api/Catalog/Categorias/';
var AddCategoria = /** @class */ (function (_super) {
    __extends(AddCategoria, _super);
    function AddCategoria(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { title: "", loading: true, dtoData: new FetchCategoria_1.CategoriaData };
        var dtoid = _this.props.match.params["id"];
        // This will set state for Edit employee  
        if (dtoid > 0) {
            fetch(categoria + dtoid)
                .then(function (response) { return response.json(); })
                .then(function (data) {
                _this.setState({ title: "Edit", loading: false, dtoData: data });
            });
        }
        // This will set state for Add employee  
        else {
            _this.state = { title: "Create", loading: false, dtoData: new FetchCategoria_1.CategoriaData };
        }
        // This binding is necessary to make "this" work in the callback  
        _this.handleSave = _this.handleSave.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        return _this;
    }
    AddCategoria.prototype.handleInputChange = function (event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        var dto = this.state.dtoData;
        dto[name] = value;
        this.setState({ dtoData: dto });
    };
    AddCategoria.prototype.render = function () {
        var contents = this.state.loading
            ? React.createElement("p", null,
                React.createElement("em", null, "Loading..."))
            : this.renderCreateForm();
        return React.createElement("div", null,
            React.createElement("h1", null, this.state.title),
            React.createElement("h3", null, "Employee"),
            React.createElement("hr", null),
            contents);
    };
    AddCategoria.prototype.handleSave = function (event) {
        var _this = this;
        //type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];        
        event.preventDefault();
        var forma = new FormData(event.target);
        var dto = this.state.dtoData;
        forma.forEach(function (value, clave) {
            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;
        });
        var data = JSON.stringify(dto);
        // PUT request for Edit employee.  
        if (this.state.dtoData.idCategoria > 0) {
            fetch(categoria + this.state.dtoData.idCategoria, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: data,
            }).then(function (response) { return response.json(); })
                .then(function (responseJson) {
                _this.props.history.push("/fetch-categoria");
            });
        }
        // POST request for Add employee.  
        else {
            fetch(categoria, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: data,
            }).then(function (response) { return response.json(); })
                .then(function (responseJson) {
                _this.props.history.push("/fetch-categoria");
            });
        }
    };
    // This will handle Cancel button click event.  
    AddCategoria.prototype.handleCancel = function (e) {
        e.preventDefault();
        this.props.history.push("/fetch-categoria");
    };
    // Returns the HTML Form to the render() method.  
    AddCategoria.prototype.renderCreateForm = function () {
        return (React.createElement("form", { onSubmit: this.handleSave },
            React.createElement("div", { className: "form-group row" },
                React.createElement("input", { type: "hidden", name: "idCategoria", value: this.state.dtoData.idCategoria }),
                React.createElement("input", { type: "hidden", name: "dtUltimoCambio", value: this.state.dtoData.dtUltimoCambio }),
                React.createElement("input", { type: "hidden", name: "rowVersion", value: this.state.dtoData.rowVersion })),
            React.createElement("div", { className: "form-group row" },
                React.createElement("label", { className: " control-label col-md-12", htmlFor: "Name" }, "Name"),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("input", { className: "form-control", type: "text", name: "txNombreCategoria", defaultValue: this.state.dtoData.txNombreCategoria, required: true }))),
            React.createElement("div", { className: "form-group row" },
                React.createElement("label", { className: " control-label col-md-12", htmlFor: "Name" }, "Institucional"),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("input", { className: "form-control", name: "bdInstitucional", type: "checkbox", checked: this.state.dtoData.bdInstitucional, onChange: this.handleInputChange, value: "true" }))),
            React.createElement("div", { className: "form-group row" },
                React.createElement("label", { className: " control-label col-md-12", htmlFor: "Name" }, "Estado"),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("input", { className: "form-control", name: "bdEstadoRegistro", type: "checkbox", checked: this.state.dtoData.bdEstadoRegistro, onChange: this.handleInputChange, value: "true" }))),
            React.createElement("div", { className: "form-group" },
                React.createElement("button", { type: "submit", className: "btn btn-default" }, "Save"),
                React.createElement("button", { className: "btn", onClick: this.handleCancel }, "Cancel"))));
    };
    return AddCategoria;
}(React.Component));
exports.AddCategoria = AddCategoria;
//# sourceMappingURL=AddCategoria.js.map